import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Input, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  OperationRequestCounts,
  OperationRequestTab,
} from 'models/OperationRequest';

import './OpsFilters.scss';

const { Search } = Input;

interface OpsFiltersProps {
  term: string;
  tab: OperationRequestTab;
  counts: OperationRequestCounts;
  loading?: boolean;
  onTermChange: (term: string) => void;
  onTabChange: (tab: OperationRequestTab) => void;
  onCreate: () => void;
}

const TAB_KEYS: {
  key: OperationRequestTab;
  countKey: keyof OperationRequestCounts;
}[] = [
  { key: 'todas', countKey: 'todas' },
  { key: 'borrador', countKey: 'borrador' },
  { key: 'pendiente', countKey: 'pendiente' },
  { key: 'en-curso', countKey: 'en-curso' },
  { key: 'riesgo', countKey: 'riesgo' },
  { key: 'listo', countKey: 'listo' },
  { key: 'publicado', countKey: 'publicado' },
  { key: 'cancelado', countKey: 'cancelado' },
];

function OpsFilters({
  term,
  tab,
  counts,
  loading,
  onTermChange,
  onTabChange,
  onCreate,
}: OpsFiltersProps) {
  const { t } = useTranslation();
  const i18nBase = 'scenes.requirements_operation.scene';

  return (
    <div className="ops-filters">
      <div className="ops-filters__header">
        <div className="ops-filters__titles">
          <h1 className="ops-filters__title">{t(`${i18nBase}.title`)}</h1>
        </div>
        <Space wrap className="ops-filters__actions">
          <Button type="primary" icon={<PlusOutlined />} onClick={onCreate}>
            {t(`${i18nBase}.buttons.create`)}
          </Button>
        </Space>
      </div>

      <Card className="ops-filters__card" bordered>
        <div className="ops-filters__search-row">
          <span className="ops-filters__search-label">
            {t(`${i18nBase}.filters.label`)}
          </span>
          <Search
            allowClear
            disabled={loading}
            className="ops-filters__search-input"
            placeholder={t(`${i18nBase}.filters.search_placeholder`)}
            value={term}
            onChange={(e) => onTermChange(e.target.value)}
            onSearch={(value) => onTermChange(value)}
          />
        </div>

        <div className="ops-filters__pills" role="tablist">
          {TAB_KEYS.map(({ key, countKey }) => {
            const active = tab === key;
            return (
              <button
                key={key}
                type="button"
                role="tab"
                aria-selected={active}
                className={`ops-filters__pill${
                  active ? ' ops-filters__pill--active' : ''
                }`}
                disabled={loading}
                onClick={() => onTabChange(key)}
              >
                <span className="ops-filters__pill-label">
                  {t(`${i18nBase}.filters.tabs.${key}`)}
                </span>
                <span className="ops-filters__pill-count">
                  {counts[countKey]}
                </span>
              </button>
            );
          })}
        </div>
      </Card>
    </div>
  );
}

export default OpsFilters;
